import { render, staticRenderFns } from "./ordersOverviewFilterBox.vue?vue&type=template&id=2e65b63e&"
import script from "./ordersOverviewFilterBox.vue?vue&type=script&lang=ts&"
export * from "./ordersOverviewFilterBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports